import React from "react";
import {SvgIcon, SvgIconProps} from "@material-ui/core"


const DashboardIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props}>
            <svg version="1.1" id="Layer_1" x="0px" y="0px"
                 strokeWidth='30px'
                 viewBox="0 0 1500 1500">
                <g>
                    <path fill="fill:#2196F3" d="M578.121,0"/>
                    <path fill="fill:#1976D2" d="M578.121,624.996"/>
                    <path fill="fill:#2196F3" d="M1390.629,999.996"/>
                    <path fill="fill:#1976D2" d="M1390.629,0"/>
                    <path fill="fill:#2EA0DC" d="M578.121,500.004h-468.75C49.061,500.004,0,450.943,0,390.621v-281.25C0,49.061,49.061,0,109.371,0
		h468.75c60.322,0,109.383,49.06,109.383,109.371v281.25C687.504,450.943,638.443,500.004,578.121,500.004L578.121,500.004z
		 M109.371,93.75c-8.616,0-15.621,7.005-15.621,15.621v281.25c0,8.628,7.005,15.633,15.621,15.633h468.75
		c8.628,0,15.633-7.005,15.633-15.633v-281.25c0-8.616-7.005-15.621-15.633-15.621H109.371z M109.371,93.75"/>
                    <path fill="fill:#2EA0DC" d="M578.121,1500h-468.75C49.061,1500,0,1450.939,0,1390.629v-656.25
		c0-60.322,49.061-109.383,109.371-109.383h468.75c60.322,0,109.383,49.061,109.383,109.383v656.25
		C687.504,1450.939,638.443,1500,578.121,1500L578.121,1500z M109.371,718.746c-8.616,0-15.621,7.005-15.621,15.633v656.25
		c0,8.616,7.005,15.621,15.621,15.621h468.75c8.628,0,15.633-7.005,15.633-15.621v-656.25c0-8.628-7.005-15.633-15.633-15.633
		H109.371z M109.371,718.746"/>
                    <path fill="fill:#2EA0DC" d="M1390.629,1500h-468.75c-60.322,0-109.383-49.061-109.383-109.371v-281.25
		c0-60.322,49.061-109.383,109.383-109.383h468.75c60.311,0,109.371,49.061,109.371,109.383v281.25
		C1500,1450.939,1450.94,1500,1390.629,1500L1390.629,1500z M921.879,1093.746c-8.628,0-15.633,7.005-15.633,15.633v281.25
		c0,8.616,7.005,15.621,15.633,15.621h468.75c8.616,0,15.621-7.005,15.621-15.621v-281.25c0-8.628-7.005-15.633-15.621-15.633
		H921.879z M921.879,1093.746"/>
                    <path fill="fill:#2EA0DC" d="M1390.629,875.004h-468.75c-60.322,0-109.383-49.061-109.383-109.383v-656.25
		C812.496,49.061,861.557,0,921.879,0h468.75C1450.94,0,1500,49.061,1500,109.371v656.25
		C1500,825.943,1450.94,875.004,1390.629,875.004L1390.629,875.004z M921.879,93.75c-8.628,0-15.633,7.005-15.633,15.621v656.25
		c0,8.628,7.005,15.633,15.633,15.633h468.75c8.616,0,15.621-7.005,15.621-15.633v-656.25c0-8.616-7.005-15.621-15.621-15.621
		H921.879z M921.879,93.75"/>
                </g>
            </svg>
        </SvgIcon>
    )
};

export default DashboardIcon;
